module.exports = __webpack_public_path__ + "img/detail_default_bg.08a62e4e.png";